import {LogoSuiteMap as sharedLogoMap} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'
import {MicrosoftLogo} from './MicrosoftLogo'
import {AzureLogo} from './AzureLogo'
import {VisualStudioCodeLogo} from './VisualStudioCodeLogo'
import {MicrosoftCopilotLogo} from './MicrosoftCopilotLogo'

/**
 * Map of FlexSuite and shared Contentful logo name strings to React SVG components.
 *
 * Shared logos come from swp-core's ContentfulLogoSuite entrypoint so
 * IntroSection can reuse the larger Contentful-backed logo set, while
 * FlexSuite-specific logos remain defined here.
 */
export const logoMap: {[key: string]: () => React.ReactElement} = {
  ...sharedLogoMap,
  Microsoft: MicrosoftLogo,
  Azure: AzureLogo,
  'Visual Studio Code': VisualStudioCodeLogo,
  'Microsoft Copilot': MicrosoftCopilotLogo,
}
